import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import {isEmpty} from 'lodash';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function clientRequestSetupReducer(state = initialState.clientRequestSetup, action) {
	switch (action.type) {
		case types.GET_CLIENT_ENGAGEMENT_NAME: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				return {...state, clientEngagementName: action.response, ipFiltering: state.ipFiltering};
			}

			return state;
		}
		case types.CLEAN_CLIENT_ENGAGEMENT_NAME: {
			return {...state, clientEngagementName: action.response, ipFiltering: state.ipFiltering};
		}
		case types.UPDATE_CLIENT_ENGAGEMENT_NAME: {
			return state;
		}
		case types.GET_CLIENT_ACCESS_LOCATIONS: {
			return {...state, clientEngagementName: state.clientEngagementName, ipFiltering: action.response};
		}
		case types.CLEAN_CLIENT_ACCESS_LOCATIONS: {
			return {...state, clientEngagementName: state.clientEngagementName, ipFiltering: {}};
		}
		case types.CREATE_CLIENT_ACCESS_LOCATIONS: {
			return state;
		}
		case types.DELETE_ACCESS_LOCATION: {
			if (action.responseObj?.status === HttpStatusCodes.NoContent) {
				if (!isEmpty(state)) {
					let locationsFiltered = state.ipFiltering?.filters?.filter(
						(location) => location.id !== action.accessLocationGuid
					);
					return {
						...state,
						ipFiltering: {
							...state?.ipFiltering,
							filters: locationsFiltered
						}
					};
				}

				return state;
			}

			return state;
		}
		case types.IMPORT_ACCESS_LOCATIONS: {
			if (action.responseObj?.status === HttpStatusCodes.Created) {
				return {
					...state,
					ipFiltering: action.response
				};
			}
			return state;
		}
		default:
			return state;
	}
}
